// extracted by mini-css-extract-plugin
module.exports = {"page":"ProductsCars_page_a5V6T","pagination":"ProductsCars_pagination_2W9F3"};